/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  userInfo: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.userInfo = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userInfo = null;
    },
    updateUserInfo: (state, action) => {
      if (!state.userInfo) {
        // If userInfo is null, set it directly
        state.userInfo = action.payload;
        // Set auth state based on new payload if there's an _id
        if (action.payload?._id) {
          state.isAuthenticated = true;
        }
      } else {
        // Otherwise merge with existing userInfo - keep auth state
        state.userInfo = {
          ...state.userInfo,
          ...action.payload,
        };
      }
    },
  },
});

export const { login, logout, updateUserInfo } = userSlice.actions;

export default userSlice.reducer;
